import React, { Fragment, useContext } from 'react'
import { Typography, Grid, Divider, Fade } from '@mui/material'
import { ConfigurationContext } from '../configurationContext'
import { InputConfiguration } from '../InputConfiguration/InputConfiguration'
import { TypeProcess as ITypeProcess } from '../../../interfaces/TypeProcess/TypeProcess'
import { useStyles } from '../styles'
interface TypeProcessProps {}

export const TypeProcess: React.FC<TypeProcessProps> = () => {
  const classes = useStyles()
  const { state, handleChange } = useContext(ConfigurationContext)
  const { typeProcess } = state

  return (
    <Fade in={true}>
      <Grid container spacing={4} direction='row' alignItems='center'>
        {typeProcess.length > 0 &&
          typeProcess.map((t: ITypeProcess) => {
            return (
              <Fragment>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Typography
                    gutterBottom
                    variant='h6'
                    className={classes.titleText}
                  >
                    {t.description}
                  </Typography>
                  <Divider variant='middle' />
                </Grid>
                <InputConfiguration
                  typeValue={'string'}
                  id={`${t.name}`}
                  name={`${t.name}`}
                  value={`${t.urlProcess}`}
                  label={`Url ${t.description}`}
                  placeholder={`Ingrese Url ${t.description}`}
                  toolTipText={`Url o Link de ${t.description}`}
                  typeConfigurationId={t.typeProcessId}
                  onChange={handleChange}
                />
              </Fragment>
            )
          })}
      </Grid>
    </Fade>
  )
}
